export enum DurationType {
	Weeks = -1,
	Months = -2,
	Years = -3,
	// TODO add back in lifetime 
	// Lifetime = -4
}